// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCjVQB336PMCbsSSiMipB3e3a9gwyBdjaQ",
  authDomain: "theapp-428906.firebaseapp.com",
  projectId: "theapp-428906",
  storageBucket: "theapp-428906.firebasestorage.app",
  messagingSenderId: "497367216215",
  appId: "1:497367216215:web:cb477dbe6e577f47e2f312"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'us-central1');

export { auth, db, storage, functions };